import { Routes } from '@angular/router';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { ATTRACTION_CONFIG } from './base/attraction-configs';

/**
 * 관광지 전용 라우팅
 *
 * mrhst 통합 라우팅과 독립적으로 동작.
 * ATTRACTION_CONFIG.routePath 경로로 등록.
 */
export const attractionRoutes: Routes = [
  {
    path: ATTRACTION_CONFIG.routePath,
    canActivate: [permissionGuard('ATTRACTION_GOODS$READ')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/attraction-list-page/attraction-list-page.component'
          ).then((m) => m.AttractionListPageComponent),
        data: {
          config: ATTRACTION_CONFIG,
          title: '관광지',
        },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/attraction-detail-page/attraction-detail-page.component'
              ).then((m) => m.AttractionDetailPageComponent),
            data: {
              config: ATTRACTION_CONFIG,
              title: '관광지 상세',
            },
          },
        ],
      },
    ],
  },
];
